import { AlarmView, LicenseType, System } from "@ews/react-data";
import { eventDetails, PushCategory } from "@ews/zlt-events";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import React, { useCallback } from "react";
import { useHasLicense } from "../HasLicense";
import Header from "../Header/System";
import { useInactiveTimeout } from "../Interval";
import { useMyProfileId } from "../Login/LoginProvider";
import { useNamedRoutes } from "../NamedRoutes";
import Navigation from "../Navigation";
import { useSystemRTM } from "../ReactData/system";
import { useUserDetails } from "../ReactData/user";
import { SystemLayoutProps } from "./types";


const InActiveRedirectFireAlarm: React.FC<{ system?: System; }> = ({ system }) =>
{
    const myId = useMyProfileId();
    const router = useIonRouter();

    const { generate } = useNamedRoutes();

    const hasDetailView = useHasLicense(LicenseType.DETAIL_VIEW);
    const hasPlanLicense = useHasLicense(LicenseType.PLAN_VIEW);

    const userDetails = useUserDetails(myId);
    const { alarmView } = userDetails;


    const rtm = useSystemRTM(system?.id || "");

    const fireAlarms = rtm.filter(rtm =>
    {
        const event = eventDetails(rtm.eventKindType || 0);
        const isFireAlarm = event.push === PushCategory.FireAlarm;

        return isFireAlarm;
    });

    const hasFireAlarms = fireAlarms.length > 0;

    const timeoutDelay = system?.id && fireAlarms.length !== 0 ? (30 * 1000) : 0;
    const fireAlarmPlanId = fireAlarms[0]?.systemPlanId || null;
    const systemId = system?.id;

    const redirect = useCallback(() =>
    {

        if (!systemId || !hasFireAlarms) return;

        let link: string | null = null;

        if (alarmView === AlarmView.plan && hasPlanLicense) {

            const params: Record<string, string> = { id: systemId };

            if (fireAlarmPlanId) {
                params.planId = fireAlarmPlanId;
            }
            link = generate("system:plan", params);
        }
        else if (hasDetailView) {
            link = generate("system:events", { id: systemId, page: "1" });
        }

        if (link) {
            router.push(link);
        }
    }, [alarmView, fireAlarmPlanId, generate, hasDetailView, hasFireAlarms, hasPlanLicense, router, systemId]);

    useInactiveTimeout(redirect, timeoutDelay);

    return <></>;
};


const Layout: React.FC<SystemLayoutProps> = ({
    header = true,
    children,
    system,
    sidebar,
    statusbar,
    navbar,
    backbutton,
    title,
    id = '',
}) =>
{

    return <>
        {header ? <Header id={(system?.systemNumber || "") + ""} backbutton={backbutton} title={title || ""} /> : false}
        <Navigation sidebar={sidebar} statusbar={statusbar} navbar={navbar} id={id} hasHeader={header}>
            <IonPage>
                {system?.id && id !== "system" ? <InActiveRedirectFireAlarm system={system} /> : null}
                <IonContent fullscreen>
                    {children}
                </IonContent>
            </IonPage>
        </Navigation>
    </>;
};

export default Layout;
